export default class AddressAutoComplete {
    constructor($view) {
        this.view = $view;
        this.bind($view);
    }

    bind($view) {
        this.view = $($view);
        var url = this.view.data("autocompleteUrl");
        $(document).ready(function () {
            $("#autoCompleteApiAddress").kendoAutoComplete({
                minLength: 5,
                dataTextField: "street",
                template: kendo.template($("#template").html()),
                ignoreCase: true,
                filter: "contains",
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            var value;
                            if ($("#autoCompleteApiAddress").data("kendoAutoComplete") === undefined) {
                                options.success([]);
                                return;
                            }
                            else {
                                value = $("#autoCompleteApiAddress").data("kendoAutoComplete").value();
                                if (value === '' || value === undefined || value === null) {
                                    options.success([]);
                                    return;
                                }
                            }
                            var countryId = $("#Adresse_Wipoz_PaysID").data("kendoDropDownList").value();
                            $.ajax({
                                url: kendo.format("{0}?StreetName={1}&countryId={2}", url, value, countryId),
                                type: "GET",
                                dataType: 'json',
                                success: function (data) {
                                    options.success($.map(data, function (item) {
                                        return window.addressFormatter(item);
                                    }));
                                    return;
                                },
                                error: function () {
                                    options.error([]);
                                    return;
                                }
                            });
                        }
                    },
                    serverFiltering: true
                }),
                change: function () {
                    this.dataSource.read();
                },
                select: function (e) {
                    var item = e.dataItem;
                    $('.js-api-zipcode').val(item.postcode);
                    $('.js-api-city').val(item.city);
                }
            });

            $("#autoCompleteApiZipcode").kendoAutoComplete({
                minLength: 4,
                dataTextField: "postcode",
                template: kendo.template($("#template").html()),
                ignoreCase: true,
                filter: "contains",
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            var value;
                            if ($("#autoCompleteApiZipcode").data("kendoAutoComplete") === undefined) {
                                options.success([]);
                                return;
                            }
                            else {
                                value = $("#autoCompleteApiZipcode").data("kendoAutoComplete").value();
                                if (value === '' || value === undefined || value === null) {
                                    options.success([]);
                                    return;
                                }   
                            }

                            var countryId = $("#Adresse_Wipoz_PaysID").data("kendoDropDownList").value();

                            $.ajax({
                                url: kendo.format("{0}?PostalCode={1}&countryId={2}", url, value, countryId),
                                type: "GET",
                                dataType: 'json',
                                success: function (data) {
                                    options.success($.map(data, function (item) {
                                        return window.zipCodeFormatter(item);
                                    }));
                                    return;
                                },
                                error: function () {
                                    options.error([]);
                                    return;
                                }
                            });
                        }
                    },
                    serverFiltering: true
                }),
                change: function () {
                    this.dataSource.read();
                },
                select: function (e) {
                    var item = e.dataItem;
                    $('.js-api-city').val(item.city);
                }
            });

            $("#autoCompleteApiCity").kendoAutoComplete({
                minLength: 5,
                dataTextField: "city",
                template: kendo.template($("#template").html()),
                ignoreCase: true,
                filter: "contains",
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            var value;
                            if ($("#autoCompleteApiCity").data("kendoAutoComplete") === undefined) {
                                options.success([]);
                                return;
                            }
                            else {
                                value = $("#autoCompleteApiCity").data("kendoAutoComplete").value();
                                if (value === '' || value === undefined || value === null) {
                                    options.success([]);
                                    return;
                                }
                            }
                            var countryId = $("#Adresse_Wipoz_PaysID").data("kendoDropDownList").value();
                            $.ajax({
                                url: kendo.format("{0}?City={1}&countryId={2}", url, value, countryId),
                                type: "GET",
                                dataType: 'json',
                                success: function (data) {
                                    options.success($.map(data, function (item) {
                                        return window.cityFormatter(item);
                                    }));
                                    return;
                                },
                                error: function () {
                                    options.error([]);
                                    return;
                                }
                            });
                        }
                    },
                    serverFiltering: true
                }),
                change: function () {
                    this.dataSource.read();
                },
                select: function (e) {
                    var item = e.dataItem;
                    $('.js-api-zipcode').val(item.postcode);
                }
            });
        });

        window.addressFormatter = function (item) {
            return {
                label: item.Label,
                street: item.StreetName,
                postcode: item.PostalCode,
                city: item.City,
                value: item.Label
            };
        }

        window.zipCodeFormatter = function (item) {
            return {
                label: item.PostalCode + ' - ' + item.City,
                city: item.City,
                value: item.PostalCode,
            };
        }

        window.cityFormatter = function (item) {
            return {
                label: item.PostalCode + ' - ' + item.City,
                postcode: item.PostalCode,
                city: item.City,
                value: item.City
            };
        }
    }
}